// src/integrations/formConfigAdapters/bitlyFormConfigAdapter.js

function asStringOrNull(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed || null;
}

function serializeBitlyConfig(rawConfig = {}) {
  const outputAction =
    asStringOrNull(rawConfig.outputAction) || 'displayInCard';

  const fallbackSource =
    outputAction === 'addToSubmissionsTable'
      ? 'responseUfi'
      : 'displayInCardMessage';

  const destinationUrlSource =
    asStringOrNull(rawConfig.destinationUrlSource) || fallbackSource;

  return {
    enabled: rawConfig.enabled === true,
    outputAction,
    destinationUrlSource,
    destinationUfi: asStringOrNull(rawConfig.destinationUfi),
    destinationFieldKey: asStringOrNull(rawConfig.destinationFieldKey),
    fallbackMode:
      asStringOrNull(rawConfig.fallbackMode) ||
      'return_long_url_if_shortlink_fails',
    domain: asStringOrNull(rawConfig.domain) || 'bit.ly',
    groupGuid: asStringOrNull(rawConfig.groupGuid),
  };
}

const bitlyFormConfigAdapter = {
  provider: 'bitly',
  publishable: true,
  saveCallableName: 'saveFormIntegrationConfig',
  publishCallableName: 'publishFormIntegrationConfig',
  serialize: serializeBitlyConfig,
};

export default bitlyFormConfigAdapter;